import classNames from "classnames";
import { useMemo } from "react";
import { cleanUrlDisplay } from "../../lib/clean-url-display";
import { formatPhoneNumber } from "../../lib/format-phone-number";
import { ExternalConnection } from "../../types/User";

export function PublicSocialLink({ social }: { social: ExternalConnection }) {
  const { bodyText, link, icon } = useMemo(() => {
    if (social.type === "none") {
      return { bodyText: null, link: null, icon: null };
    }

    if (social.type === "text") {
      return { bodyText: social.value, link: null, icon: "notes" };
    }

    if (social.type === "email") {
      return {
        bodyText: social.value,
        link: `mailto:${social.value}`,
        icon: "alternate_email",
      };
    }

    if (social.type === "phone") {
      return {
        bodyText:
          social.value.length === 10
            ? formatPhoneNumber(social.value)
            : social.value,
        link: `tel:${social.value}`,
        icon: "phone",
      };
    }

    if (social.type === "instagram") {
      let instagramHandle = social.value;
      if (!instagramHandle.startsWith("@")) {
        instagramHandle = `@${instagramHandle}`;
      }

      return {
        bodyText: instagramHandle,
        link: `https://www.instagram.com/${instagramHandle}`,
        icon: "numbers",
      };
    }

    if (social.type === "linkedin") {
      return {
        bodyText: cleanUrlDisplay(social.value),
        link: social.value,
        icon: "business_center",
      };
    }

    return { bodyText: "", link: "", icon: null };
  }, [social]);

  const linkClassNames = classNames(
    "public-social-link",
    `social-${social.type}`
  );

  if (social.type === "none") {
    return null;
  }

  if (link) {
    return (
      <div className={linkClassNames}>
        {icon && <span className="material-icons">{icon}</span>}
        <a href={link} target="_blank" rel="noopener noreferrer">
          {bodyText}
        </a>
      </div>
    );
  }

  return (
    <div className={linkClassNames}>
      {icon && <span className="material-icons">{icon}</span>}
      <span>{bodyText}</span>
    </div>
  );
}
